import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'components/UI/Link'
import DashboardPopup from '../DashboardPopup'
import Button from 'components/UI/Button/Button'
import {
  Title,
  Subtitle,
  ButtonRow
} from './UpgradePopup.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class UpgradePopup extends Component {
  static propTypes = {
    emails: PropTypes.arrayOf(PropTypes.string)
  }

  render () {
    const { subscriptionStatus } = this.props

    const titles = {
      trial: 'Upgrade your account',
      stripe: 'Upgrade to a custom plan',
      custom: 'Upgrade your custom plan',
      expired: 'Renew your subscription'
    }

    const subtitles = {
      trial: 'Upgrade your account to add more teachers to your school! Press the button below to learn more.',
      stripe: 'Upgrade to a custom plan to add more teachers to your school! Press the button below to learn more.',
      custom: 'Upgrade your custom plan to add more teachers to your school! Press the button below to learn more.',
      expired: 'Renew your subscription to add more teachers to your school! Press the button below to learn more.'
    }

    return (
      <DashboardPopup
        onCancel={this.props.onCancel}
        isSettings
      >
        <Title>
          {titles[subscriptionStatus]}
        </Title>
        <Subtitle>
          {subtitles[subscriptionStatus]}
        </Subtitle>
        <ButtonRow>
          <Button
            bgColor={colors.lightBlue}
            color='white'
            size='regular'
            onClick={() => window.open('/edu/dashboard/settings/subscription', '_self')}
          >
            Learn more
          </Button>
        </ButtonRow>
      </DashboardPopup>
    )
  }
}
